import { gql } from '@apollo/client';

export type RefundInput = {
  amountRefund: number;
  notes: string;
  order_id: number;
  totals: number;
  paymentType: string;
  fullRefund: boolean;
}

// Hasura mutation action -> ronin-api/api/refund_order.js. The server derives
// the tender, the processor, the amount and the tax split; the client only
// states what happened to the goods and, for line items, which units.
export type RefundOrderInput = {
  order_id: number;
  refund_type: "void" | "full" | "line_item";
  items?: { item_id: string; price: number; modifier_ids: number[]; quantity: number; paid_with_token?: boolean }[];
  refund_tip?: boolean;
  refund_digital_surcharge?: boolean;
  reason_code?: string | null;
  reason?: string | null;
  note?: string | null;
  idempotency_key: string;
};

export const REFUND_ORDER_V2 = gql`
  mutation refundOrder($object: RefundOrderInput!) {
    refundOrder(object: $object) {
      statusMessage
      order_refund_id
      processor_action
      amount
      status
      money_outcome
      replayed
    }
  }
`;

export const REFUND_ORDER = gql`
  mutation RefundItem($object: RefundsInsertInput) {
    insert_refunds_one(
      object: $object
    ) {
      statusMessage
    }
  }
`

export const REFUND_TICKETING_ORDER = gql`
  mutation RefundTicketingOrder($object: TicketingRefundsInsertInput) {
    insert_ticketing_refunds_one(
      object: $object
    ) {
      statusMessage
    }
  }
`